import { cn } from '@bem-react/classname';

export const cnPublication = cn('Publication');
export const publicationCn = cnPublication();
export const publicationImgCn = cnPublication('Image');
export const publicationImgContainerCn = cnPublication('ImageContainer');
export const publicationHeaderCn = cnPublication('Header');
export const publicationDescriptionCn = cnPublication('Description');
export const publicationBlockCn = cnPublication('Block');
export const publicationPriceCn = cnPublication('Price');
export const publicationDescriptionSubheaderCn = cnPublication('Description-Subheader');
export const publicationDescriptionFooterCn = cnPublication('Description-Footer');

export const publicationImgSkeletonCn = cnPublication('ImageSkeleton');
export const publicationTextSkeletonCn = cnPublication('Text-Skeleton');
export const publicationLikeSkeletonCn = cnPublication('Like-Skeleton');
export const publicationPriceSkeletonCn = cnPublication('Price-Skeleton');
